














import HeaderSet from "@/components/headerSet/HeaderSet.vue";
import ModalAlertMessage from "@/components/modal/ModalAlertMessage.vue";
import { LoadingStatusType } from "@/enums/enums";
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import Liff from "@line/liff";

const StoreLineToken = namespace("LineToken");
const StoreUserInfo = namespace("UserInfo");
const StoreLoading = namespace("Loading");

@Component({ components: { HeaderSet, ModalAlertMessage } })
export default class Layout extends Vue {
  @StoreUserInfo.Getter
  private getLogInSuccess!: LoadingStatusType;
  @StoreUserInfo.Getter
  private getMerchant!: SelectedMerchantModel;
  @StoreUserInfo.Getter
  private getSetSelectMerchantLoadingStatus!: LoadingStatusType;
  @StoreLineToken.Getter
  private getLineTokenLoadingStatus!: LoadingStatusType;
  @StoreLineToken.Getter
  private getLineTokenValidate!: boolean | null;

  @StoreUserInfo.Action
  private DoSelectMerchant!: (merchantId: number) => void;
  @StoreLineToken.Action
  private LineTokenAutorize!: (_input: any) => void;
  @StoreLoading.Action
  private IsLoading!: (loadingStatus: boolean) => void;

  private color = "";
  private renderElement = false;

  beforeCreate() {
    const liffId = process.env.VUE_APP_LineDocumentLiffId ?? "";
    Liff.init({ liffId: liffId })
      .then(() => {
        const isLiff = Liff.isInClient() && Liff.isLoggedIn();
        if (isLiff) {
          const token = Liff.getAccessToken();
          this.LineTokenAutorize(token);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  created() {
    this.IsLoading(true);
  }

  @Watch("$route", { immediate: true })
  RouteChanged(newVal: any, oldVal: any) {
    if (newVal.name) {
      this.SetColorPage(newVal.name);
    }
  }

  public SetColorPage(routerName: string) {
    switch (routerName) {
      case "quotationCreate":
        this.color = "#6361F4";
        break;
      case "invoiceCreate":
        this.color = "#008DFF";
        break;
      case "receiptCreate":
        this.color = "#00BA67";
        break;
      case "expenseCreate":
        this.color = "#FFA350";
        break;
    }
  }

  @Watch("getLineTokenLoadingStatus")
  getLineTokenLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      const merchantId = MerchantId();
      this.DoSelectMerchant(merchantId);
    }
  }

  @Watch("getSetSelectMerchantLoadingStatus")
  getSetSelectMerchantLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      this.renderElement = true;
    }
  }

  @Watch("getLogInSuccess")
  getLogInSuccessChanged() {
    if (this.getLogInSuccess == LoadingStatusType.Success) {
      if (this.getLineTokenValidate) {
        if (this.$route.name == "document") {
          this.$router.push({ name: "expenseCreate" });
        }
      } else {
        this.$router.push({ name: "unauthorized" });
      }
    }
  }
}
